import React from 'react'

const ArrowUpSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 12.972 7.9'
    >
      <path
        id='Path_3207'
        data-name='Path 3207'
        d='M14906.687,3248.5l5.778,5.779,5.779-5.779'
        transform='translate(14918.951 3255.693) rotate(180)'
        fill='none'
        stroke='#C8C8C8'
        strokeWidth='2'
      />
    </svg>
  )
}

export default ArrowUpSvg
